import { render } from "./highMatchmakers.vue?vue&type=template&id=18f48b9e&scoped=true"
import script from "./highMatchmakers.vue?vue&type=script&lang=js"
export * from "./highMatchmakers.vue?vue&type=script&lang=js"

import "./highMatchmakers.vue?vue&type=style&index=0&id=18f48b9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f48b9e"]])

export default __exports__